import React, { useEffect } from "react";
import { useLogModel } from "./logModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { LogDataTable } from "./DataTable";

export const LogDataBox = () => {
    const {
        state,
        dataSource,
        loadData,
        selectedRowKeys,
        setSelectedData,
    } = useLogModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [state])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "测试",
            value: "123",
            color: DescriptionColorEnum.green
        },
        {
            label: "测试2",
            value: "33.233",
            color: DescriptionColorEnum.red
        }
    ]

    const onOpenAccount = () => {

    }
    const onAdjust = () => {

    }
    const onRecharge = () => {

    }
    const onTransfer = () => {

    }

    return (
        <>
            <YhBox title={"操作日志"} >
                <LogDataTable />
            </YhBox>
        </>
    )
}